import React from 'react';
import { history, a11yAnnounce } from 'fn-common-ui';

export class PageAnnouncer extends React.Component {

	constructor(props) {
		super(props);
		history.listen(({ location }) => {
			this.determinePageName(location.pathname)
		});
	}

	determinePageName(pathName) {
		let pageName = '',
		invariantPageNames = {
			'/faq': 'Frequently Asked Questions',
			'/new-application/app-details/': 'New Application Form. Step 1: App Details',
			'/new-application/app-package/': 'New Application Form. Step 2: App Package',
			'/new-application/app-screenshots/': 'New Application Form. Step 3: App Screenshots',
			'/new-application/app-review/': 'New Application Form. Step 4: App Review',
			'/new-application/app-submit/': 'New Application Form. Step 5: App Submission'
		};

		if (pathName.includes('/app/')) {
			pageName = 'App Details';
			if (pathName.includes('edit')) {
				pageName += ' in edit mode.';
			}
			if (pathName.includes('review')) {
				pageName += '. Reviewing changes.';
			}
		} else if (pathName === '/' || pathName === '/my-apps') {
			pageName = 'App Control My Apps';
		} else {
			const pageString = Object.keys(invariantPageNames).find(name => new RegExp(name).test(pathName));
			pageName = invariantPageNames[pageString];
		}

		a11yAnnounce({
			message: `Currently displaying ${pageName}`,
			messageType: 'status'
		})

	}

	render(){
		return(
			<div className="sr-only" id="global-a11y-announcer">
				<span role="alert" className="sr-only" id="global-a11y-alert-announcer"></span>
				<span role="status" className="sr-only" id="global-a11y-status-announcer"></span>
			</div>
		);
	}
}
